import React from 'react';
import styles from './DeleteModal.module.scss';
import { Button, Icon } from 'components/ui';
import ReactModal from 'react-modal';

type DeleteModalProps = {
  isOpen: boolean;
  handleClose: () => void;
  handleDelete?: () => void;
  name?: string;
};
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};
if (process.env.NODE_ENV !== 'test') ReactModal.setAppElement('#modal');

const DeleteModal: React.FC<DeleteModalProps> = ({ isOpen, handleClose, handleDelete, name }) => (
  <ReactModal isOpen={isOpen} style={customStyles}>
    <div className={styles['root']}>
      <div className={styles['title']}>Are you sure you’d like to remove the dependent? This cannot be undone. <br/>Associated files will still be available on the Records & Forms page.</div>
      <div className={styles['buttons']}>
        <Button id="delete" className={styles['button']} onClick={handleDelete}>
          Yes, delete
        </Button>
        <Button className={styles['button']} onClick={handleClose}>
          No, cancel
        </Button>
      </div>
      <Icon className={styles['icon']} name="close" onClick={handleClose} />
    </div>
  </ReactModal>
);

export default DeleteModal;
